import { Button, Table, TableColumnsType } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RoleListContainerStaffRoleFieldsFragment } from '../../../../generated';
import { FormatDate } from '../../../../constants';


interface RoleListProps {
  data: RoleListContainerStaffRoleFieldsFragment[];
  canAddRole: boolean;
}

export const RoleList: React.FC<RoleListProps> = (props) => {
  const navigate = useNavigate();

  const columns: TableColumnsType<RoleListContainerStaffRoleFieldsFragment> = [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_: any, record: any) => (
        <Button
          type="primary"
          onClick={() => {
            navigate(`detail/${record.id}`);
          }}
        >
          Edit
        </Button>
      )
    },
    {
      title: 'Role Name',
      dataIndex: 'roleName',
      key: 'roleName'
    },
    {
      title: 'Is Default',
      dataIndex: 'isDefault',
      key: 'isDefault',
      render: (isDefault: boolean) => (isDefault ? 'True' : 'False'),
      // sort by isDefault
      sorter: (a: any, b: any) => a.isDefault - b.isDefault
    },
    {
      title: 'Updated',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (updatedAt: string) => FormatDate(updatedAt),
      sorter: (a: any, b: any) => dayjs(a.updatedAt).diff(dayjs(b.updatedAt))
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt: string) => FormatDate(createdAt),
      sorter: (a: any, b: any) => dayjs(a.createdAt).diff(dayjs(b.createdAt))
    }
  ];

  return (
    <>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          textAlign: 'left'
        }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: '10px',
          marginTop: '-65px',
          marginRight: '10px'
        }}
      >
        <Button
          type="primary"
          disabled={!props.canAddRole}
          onClick={() => {
            navigate('create');
          }}
        >
          Add New Role
        </Button>
      </div>
      <Table
        style={{
          width: '75%',
          border: '1px solid #f0f0f0',
          borderRadius: '10px',
          padding: '15px',
          maxWidth: '100%'
        }}
        columns={columns}
        dataSource={props.data.filter((role) => role.roleName !== 'IS Admin' )}
        rowKey="id"
        pagination={false}
        rowHoverable={false}
      />
    </>
  );
};
